// extracted by mini-css-extract-plugin
export var avatarContainer = "_gi-0";
export var avatarTypingWave = "_gi-i";
export var gray = "_gi-f";
export var green = "_gi-c";
export var icon = "_gi-9";
export var image = "_gi-1";
export var lg = "_gi-6";
export var md = "_gi-5";
export var presenceDot = "_gi-b";
export var red = "_gi-d";
export var sm = "_gi-4";
export var status = "_gi-a";
export var typingDot = "_gi-h";
export var typingPill = "_gi-g";
export var xl = "_gi-7";
export var xs = "_gi-3";
export var xxl = "_gi-8";
export var xxs = "_gi-2";
export var yellow = "_gi-e";